"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");exports.__esModule=!0,exports.default=ready;var _invoker=_interopRequireDefault(require("./invoker"));function ready(e){"function"==typeof e?_invoker.default.onReady(e):console.error("dd.ready's param must be function! ")}module.exports=exports.default,module.exports.default=exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/gdt-jsapi/ready.js
// module id = y5Y0
// module chunks = 23